const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path
            d="M25.648 0c14.164 0 25.647 11.505 25.647 25.698 0 14.192-11.483 25.698-25.647 25.698C11.483 51.396 0 39.89 0 25.698 0 11.505 11.483 0 25.648 0zm0 3.504c-12.234 0-22.15 9.937-22.15 22.194s9.916 22.193 22.15 22.193c12.233 0 22.15-9.936 22.15-22.193 0-12.257-9.917-22.194-22.15-22.194zm0 31.538a2.334 2.334 0 012.331 2.337 2.334 2.334 0 01-2.331 2.336 2.334 2.334 0 01-2.332-2.336 2.334 2.334 0 012.332-2.337zm1.615-23.206c3.198.615 5.764 3.153 6.387 6.329a8.088 8.088 0 01-4.76 9.04c-.898.386-1.493 1.337-1.493 2.398v1.351a1.75 1.75 0 01-1.75 1.752 1.75 1.75 0 01-1.748-1.752v-1.35c0-2.433 1.4-4.668 3.612-5.62a4.584 4.584 0 002.708-5.143c-.348-1.769-1.812-3.217-3.614-3.564-2.967-.57-5.62 1.618-5.62 4.498a1.75 1.75 0 01-1.75 1.753 1.75 1.75 0 01-1.748-1.753c0-5.084 4.657-8.922 9.776-7.94z"
            id="question-line__a" />
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path d="M0 0h56v56H0z" />
        <g transform="translate(2 2)">
            <mask id="question-line__b" fill="#fff">
                <use xlink:href="#question-line__a" />
            </mask>
            <use fill="currentColor" fill-rule="nonzero" xlink:href="#question-line__a" />
            <path fill="currentColor" mask="url(#question-line__b)" d="M-2.332-2.336h55.958v56.068H-2.332z" />
        </g>
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=question-line.es.BKau9OLO.js.map
